import "firebase/auth";
import { Button} from 'semantic-ui-react'


function SignOut({ auth }) {

    return auth.currentUser && (
        <Button style = {{ background : "grey"}} onClick={() => auth.signOut()}>SignOut</Button>
      )
  
  }

  export default SignOut;